import { Component, Input } from '@angular/core';
import { Functions } from '@hub/common/Functions';
import { CurrencyDto } from 'app/_generated/models';

@Component({
    selector: 'grid-sum',
    templateUrl: './grid-sum.component.html',
})

export class GridSumComponent {
    constructor() { }

    @Input() symbol: string = "$";
    @Input() text: string = "";
    @Input() value: number = 0;
    @Input() colorClass: string;
    @Input() currency: CurrencyDto = Functions.GetInstnceCurrency();
}
